import request from '@/utils/request'

export function updateActiveNameCfg(data) {
  return request({
    url: 'api/v1/active-name/updateActiveNameCfg',
    method: 'post',
    data: data
  })
}

export function getActiveNameCfg(data) {
  return request({
    url: 'api/v1/active-name/getActiveNameCfg',
    method: 'get',
    params: data
  })
}
